<template>
	<div>
		<div class="container container--small pdt-50 pdb-50">
				<div class="t-headline5 font-b mgt-28 mgb-18 t-center">{{$t('1519')}}</div>
				<div class="t-body1 font-r t-color-bodyGrayA t-center l-spacing48 pdl-24 pdr-24"> {{$t('1520')}}<br />
					{{$t('1521')}}</div>
					<div v-if="socialAuth === true" class=" t-body4 t-color-bodyGrayA l-spacing39 t-nowrap t-center mgt-40">{{$t('3452')}}</div>
				<div class="pdl-24 pdr-24">
					<!-- <div class="pdt-24" v-if="socialAuth === true"> -->
					<div class="pdt-24"	v-if="socialAuth === true">
						
						<div class="d-flex align-items-center justify-content-center flex-column">
                            <button class="mdc-button btn-sns-sign point-mark social-button bg-google"  @click.prevent="socialLoginAuth('google')" @keypress.prevent="socialLoginAuth('google')" v-if="isActivePlatform(platform.google)" tabindex="0">
                                <img src="../../assets/google.svg" alt="google"> <span class="pdl-12 t-body1 t-color-white t-capitalize l-spacing0">{{$t('3463')}}</span>
                            </button>
                            <button class="mdc-button btn-sns-sign point-mark facebook social-button"  @click.prevent="socialLoginAuth('facebook')" @keypress.prevent="socialLoginAuth('facebook')" v-if="isActivePlatform(platform.facebook)" tabindex="0">
                                <img src="../../assets/facebook.svg" alt="facebook"> <span class="pdl-12 t-body1 t-color-white t-capitalize l-spacing0">{{$t('3464')}}</span>
                            </button>
                           
                                <vue-telegram-login mode="callback" :telegram-login="bot" @callback="telegramCallbackFunction" size="large" class="mdc-button btn-sns-sign point-mark telegram social-button" v-if="isActivePlatform(platform.telegram)" tabindex="0" />
                           
							<button class="mdc-button btn-sns-sign point-mark social-button bg-naver"  @click.prevent="clickNaver" @keypress.prevent="clickNaver" v-if="isActivePlatform(platform.naver)" tabindex="0">
                                <img src="../../assets/naver.svg" alt="naver"> <span class="pdl-12 t-body1 t-color-white t-capitalize l-spacing0">{{$t('3465')}}</span>
                            </button> 
                            <button class="mdc-button btn-sns-sign social-button bg-apple t-capitalize l-spacing0" @click.prevent="socialLoginAuth('apple')" @keypress.prevent="socialLoginAuth('apple')" v-if="isActivePlatform(platform.apple)" tabindex="0">
                                <img src="../../assets/apple.svg" alt="apple"> <span class="pdl-12 t-body1 t-color-white">{{$t('3466')}}</span>
                            </button>
                        </div>
						<!-- <div id="naver_id_login" class="naver-wrapper social-button bg-naver" v-if="socialCode[3].active"></div> -->
					</div>
					<div class="t-center mgt-16 t-body4 t-color-signGray">{{$t('1522')}}</div>
					<div class="mgt-50">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4" @click="createAcount" @keypress="createAcount" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r"> {{$t('1523')}}</span>
						</button>
					</div>
					<div class="mgt-24">
						<span class="t-body3 font-r t-color-signGray pdl-4 pdr-4">{{$t('1524')}} </span>
						<router-link tabindex="0" to="/login" class="t-body3 font-r t-color-signRed">{{$t('1525')}}</router-link>
					</div>
				</div>
			</div>
            <div v-if="isActivePlatform(platform.naver)" id="naver_id_login"
                   class="naver-wrapper social-button bg-naver"></div>
            </div>
	</div>
</template>


<script>
/**
 * 회원가입 - 인트로(sign up - intro component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import firebase from 'firebase'
import { mapState, mapMutations } from 'vuex'
import loginApi from '@/api/loginApi.js'
import joinApi from '@/api/joinApi.js'
import brandApi from '@/api/brandApi.js'
import {vueTelegramLogin} from 'vue-telegram-login'

export default {
	data() {
		return {
			socialType: '',
			socialToken: '',
			socialFirstName: '',
			socialLastName: '',
			socialFullName: '',
			socialEmail: '',
			brandLogo: localStorage.getItem('brandLogo'),
			socialAuth: false,
			socialCode:'',
			userloginLanguage: JSON.parse(localStorage.getItem('languageInfo')).code,
			naverAcessTooken: null,
			bot:localStorage.getItem('TELEGRAM_BOT'),
      platform: {
        google: 'GOOGLE',
        facebook: 'FACEBOOK',
        telegram: 'TELEGRAM',
        apple: 'APPLE',
        naver: 'NAVER'
      },
			
		}
	},
	created() {
		this.socialCode =JSON.parse(localStorage.getItem("SOCIAL_CODE"));
	},
	components: {vueTelegramLogin},
	computed : {
		...mapState('join',{
			join : state => state,
		})
	},

	mounted() {
		this.INIT_JOIN_STORE()
		this.SET_JOINSTART(true)
		this.setMaterialUi()
		// Whether to use social subscription
		brandApi.brandInfo().then((response) => {
			this.socialAuth = response.data.data.socialAuth;
      this.socialCode = response.data.data.social;
		})

		setTimeout(()=>{
            if(this.socialAuth == true && this.socialCode[3].active) {
                const fullPath = location.protocol + '//' + location.host
                const naver_id_login = new window.naver_id_login(localStorage.getItem('NAVER_KEY'), `${fullPath}/join2/intro`);
                const state = naver_id_login.getUniqState();
                naver_id_login.setState(state);
                naver_id_login.setButton("", "",45);
                naver_id_login.init_naver_id_login();
                naver_id_login.get_naver_userprofile();
                this.naverAcessTooken  = naver_id_login.getAccessToken()
                if(this.naverAcessTooken) {
                    this.$showLoading();
                    setTimeout(()=>{
                        this.getUserDetails()
                    },2000)

                }
                    
            }
        },1000)

		
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', [
			'SET_JOINSTART', 'SET_SOCIAL_LINK', 'SET_PUSH_NOTIFICATION','SET_NAME_FIRST', 'SET_NAME_LAST', 'SET_NAME_FULL', 'SET_LOGINID', 'SET_SOCIAL_ID', 'INIT_JOIN_STORE'
		]),

        isActivePlatform(platform) {
            const socialCodeResult = this.socialCode.find(value => value.platform.name === platform);
            return socialCodeResult && socialCodeResult.active;
        },

		/*************************** Naver Signup *********************************/
		clickNaver() {
            console.log(document.getElementById("naver_id_login_anchor"))
            document.getElementById('naver_id_login_anchor').click()
        },
        getUserDetails() {
            const fullPath = location.protocol + '//' + location.host
            let naver_id_login = new window.naver_id_login(localStorage.getItem('NAVER_KEY'), `${fullPath}/join2/intro`);
            
            const state = naver_id_login.getUniqState();
            naver_id_login.getAccessToken();
            naver_id_login.get_naver_userprofile();
            this.socialFirstName =  naver_id_login.getProfileData('name')
            this.socialLastName = ''
            this.socialFullName = naver_id_login.getProfileData('name')
            this.socialEmail = naver_id_login.getProfileData('email')

            let params={
                "uid" : this.socialEmail,
                "name" : "naver",
                "type" : "naver",
                "email" : this.socialEmail
            }

            let socialEmailparams = { userId: this.socialEmail }
            joinApi.existsId(socialEmailparams).then((response) => {
                if (response.data.data) {
                    this.$hideLoading();
                    let params = {
                        
                        title: this.$t('1641'),
                        content: this.$t('1642') + ' ' + this.$t('1643'),
                        accept: this.$t('1645'),
                        cancel: this.$t('1644')
                    }
                    this.$confirm(params).then(() => {
                        firebase.auth().signOut()
                    }).catch(() => {
                        this.$moveLogin()
                    })
                } else {
                    // get custom token
                    joinApi.customToken(params).then((response) => {
                        firebase.auth().signInWithCustomToken(response.data.data).then((result) => { 
                        firebase.auth().currentUser.getIdToken().then((idToken) => {
                            this.socialToken = idToken
							this.socialType = "naver"
                            this.SET_NAME_FIRST(this.socialFirstName)
                            this.SET_NAME_LAST(this.socialLastName)
                            this.SET_NAME_FULL(this.socialFullName)
                    
                            this.SET_SOCIAL_LINK({
                                type: 'firebase',
								name: this.socialType.toUpperCase(),
                                token: this.socialToken,
                                socialType: 'naver',
                                userloginLanguage: this.userloginLanguage
                            })
                            this.SET_SOCIAL_ID(this.socialEmail)
                            this.SET_LOGINID(this.socialEmail)

                            let pushTokenByRaectNative = localStorage.getItem("fbToken")
                            this.SET_PUSH_NOTIFICATION({
                                pushToken: pushTokenByRaectNative?pushTokenByRaectNative:'',
                                pushLanguage: this.userloginLanguage,
                                // notificationed: false
                            })
                            
                            this.$hideLoading();                        
                            this.$router.push({name: 'Join2Policy', query: {
                                type: 'social'
                            }})
                        }).catch((error)=>{
                            console.log('getIdToken=>error',error)
                        })
                    }).catch((error)=>{
                        console.log('signInWithCustomToken=>error',error)
                    })      
                }).catch((error)=>{
                    console.log('customToken=>error',error)
                })
            }
                
            }).catch((error)=>{
                console.log('customToken=>error',error)
            })
        },
        /*************************** End Here *************************************/

        /****************************** Telegram signup ***************************/
        /**
        * telegram signup
        *
        * @param user gets user as an input
        */
        telegramCallbackFunction (user) {
          this.$showLoading();
            this.socialFirstName =  user.first_name
            this.socialLastName = ''
            this.socialFullName = user.first_name
            this.socialEmail = user.id

            let params = {
                "uid" : user.id,
                "name" : "telegram",
                "type" : "telegram",
                "email" : ""
            }

            let socialEmailparams = { userId: user.id + '@telegram.org' }
            joinApi.existsId(socialEmailparams).then((response) => {
                if (response.data.data) {
                    let params = {
                        
                        title: this.$t('1641'),
                        content: this.$t('1642') + ' ' + this.$t('1643'),
                        accept: this.$t('1645'),
                        cancel: this.$t('1644')
                    }
                    this.$confirm(params).then(() => {
                        firebase.auth().signOut()
                    }).catch(() => {
                        this.$moveLogin()
                    })
                } else {
                    // get custom token
                    joinApi.customToken(params).then((response) => {
                        firebase.auth().signInWithCustomToken(response.data.data).then((result) => { 
                        firebase.auth().currentUser.getIdToken().then((idToken) => {
                            this.socialToken = idToken
                            this.socialType = "telegram"
                            this.SET_NAME_FIRST(this.socialFirstName)
                            this.SET_NAME_LAST(this.socialLastName)
                            this.SET_NAME_FULL(this.socialFullName)
                    
                            this.SET_SOCIAL_LINK({
                                type: 'firebase',
								                name: this.socialType.toUpperCase(),
                                token: this.socialToken,
                                socialType: 'telegram',
                                userloginLanguage: this.userloginLanguage
                            })
                            this.SET_SOCIAL_ID(this.socialEmail)
                            this.SET_LOGINID(this.socialEmail)

                            let pushTokenByRaectNative = localStorage.getItem("fbToken")
                            this.SET_PUSH_NOTIFICATION({
                                pushToken: pushTokenByRaectNative?pushTokenByRaectNative:'',
                                pushLanguage: this.userloginLanguage,
                                // notificationed: false
                            })
                                                    
                            this.$router.push({name: 'Join2Policy', query: {
                                type: 'social'
                            }})
                        }).catch((error)=>{
                            console.log('getIdToken=>error',error)
                        })
                    }).catch((error)=>{
                        console.log('signInWithCustomToken=>error',error)
                    })      
                }).catch((error)=>{
                    console.log('customToken=>error',error)
                })
            }
                this.$hideLoading();
            }).catch((error)=>{
                console.log('customToken=>error',error)
            })

            //return
        },

        /****************************** Telegram End ************************************/

		// social login auth
		socialLoginAuth(socialType){
			let provider = null
			this.socialType = socialType

			if (socialType === 'google') {
				provider = new firebase.auth.GoogleAuthProvider()
			}else if (socialType === 'facebook') {
				provider = new firebase.auth.FacebookAuthProvider()
			} else if(socialType === 'apple') {
				provider = new firebase.auth.OAuthProvider('apple.com');
				provider.addScope('email');
                provider.addScope('name');
			}
			
			firebase.auth().signInWithPopup(provider).then((result) => {
				let providerUserInfo = null
				providerUserInfo = result.additionalUserInfo.profile
				let googleToken = result.credential.accessToken;
				if (socialType === 'google') {
					this.socialFullName = providerUserInfo.name
					this.socialEmail = providerUserInfo.email
					if(providerUserInfo.locale && providerUserInfo.locale.toLowerCase() =='ko') {
                        if(socialType=='google' && JSON.parse(localStorage.getItem('languageInfo')).code.toLowerCase()=='en') {
                            this.socialFirstName =  providerUserInfo.given_name
						    this.socialLastName = providerUserInfo.family_name
                        } else {
                            this.socialLastName =  providerUserInfo.family_name
						    this.socialFirstName = providerUserInfo.given_name
                        }
                
					} else {
						this.socialFirstName =  providerUserInfo.family_name
						this.socialLastName = providerUserInfo.given_name
					}
				}else if (socialType === 'facebook') {
					this.socialFirstName =  providerUserInfo.first_name
					this.socialLastName = providerUserInfo.last_name
					this.socialFullName = providerUserInfo.name
					this.socialEmail = providerUserInfo.email
				}else if (socialType === 'apple') {
					let displayNames = result.user.displayName
                    if(displayNames) {
                        let split_name = displayNames.split(' ')
                        this.socialFirstName =  split_name[0]
                        this.socialLastName = split_name[1]
                        this.socialFullName = displayNames
                    } else {
                        this.socialFirstName =  ''
                        this.socialLastName = ''
                        this.socialFullName = ''
                    }
                    
                    this.socialEmail = result.user.email
				}
				
				 this.$showLoading();
				// get firebase user token

				let socialEmailparams = { userId: this.socialEmail }
                    joinApi.existsId(socialEmailparams).then((response) => {
                        if (response.data.data) {
							this.$hideLoading();
                            let params = {
                                title: this.$t('1641'),
                                content: this.$t('1642') + ' ' + this.$t('1643'),
                                accept: this.$t('1645'),
                                cancel: this.$t('1644')
                            }
                            this.$confirm(params).then(() => {
                                firebase.auth().signOut()
                            }).catch(() => {
                                this.$moveLogin()
                            })
                        } else {
                            firebase.auth().currentUser.getIdToken(true).then((idToken) => {
								this.socialToken = idToken

								let params = {
									type: 'firebase',
									token: this.socialToken,
								}

							//Duplicate check
							joinApi.existsSocial(params).then((response) => {
								if (response.data.data) { 
									this.$hideLoading();
									this.$router.push({name: 'Join2ExistSocial'})
								}else {
									this.$hideLoading();
									this.SET_NAME_FIRST(this.socialFirstName)
									this.SET_NAME_LAST(this.socialLastName)
									this.SET_NAME_FULL(this.socialFullName)
									
									this.SET_SOCIAL_LINK({
										type: 'firebase',
										name: this.socialType.toUpperCase(),
										token: this.socialToken,
										socialType: socialType,
										userloginLanguage: this.userloginLanguage
									})

									this.SET_PUSH_NOTIFICATION({
										pushToken: '',
										pushLanguage: this.userloginLanguage,
										// notificationed: false
									})

									this.SET_SOCIAL_ID(this.socialEmail)
									this.SET_LOGINID(this.socialEmail)
									this.$router.push({name: 'Join2Policy', query: {
										type: 'social'
									}})
								}

								}).catch((err) => {
									this.$hideLoading();
								})

							}).catch((err) => {
								this.$hideLoading();
							})
						}
                        
                    }).catch((err) => {
                        console.log("SOCIAL LOGIN ERROR : ", err);
						this.$hideLoading();
				})
				
				
			}).catch((err) => {
                console.log("SOCIAL LOGIN ERROR : ", err);
				this.$hideLoading();
			   if (err.email && err.credential && err.code === 'auth/account-exists-with-different-credential') {
				const providers = firebase.auth().fetchSignInMethodsForEmail(err.email)
				const firstPopupProviderMethod = providers.find(p => supportedPopupSignInMethods.includes(p));

				// Test: Could this happen with email link then trying social provider?
				if (!firstPopupProviderMethod) {
					throw new Error(`Your account is linked to a provider that isn't supported.`);
				}

				const linkedProvider = getProvider(firstPopupProviderMethod);
				linkedProvider.setCustomParameters({ login_hint: err.email });

				const result = firebase.auth().signInWithPopup(linkedProvider);
				result.user.linkWithCredential(err.credential);
				}
			})
		},

		createAcount() {
			this.SET_PUSH_NOTIFICATION({
				pushToken: '',
				pushLanguage: this.userloginLanguage,
				// notificationed: false
			})
			this.$router.push(
				'policy'
			)
		},


		// 로그인 API 파라미터 설정
		setParams(loginType) {
			let params = null

			params = {
				userId: '',
				password: '',
				device: {
					type: 'WEB'
				},
				social: {
					type: this.socialType,
					token: this.socialToken
				}
			}
		
			return params
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

	},
	
}
</script>
<style scoped>
	#naver_id_login{
    	visibility: hidden;
	}
	/* div#naver_id_login {
		border-radius: 50% !important;
		margin-left: 4px !important;
		overflow: hidden;
	} */
</style>
